import React, { useState } from "react"
import styled from "styled-components"
import { useFormContext } from "react-hook-form"
import { ErrorMessage } from "@hookform/error-message"
import { kv } from "~/utils/functions"
import { Values } from "~/model/Config"
import FormLabel from "./FormLabel"
import ErrorField from "~/components/atoms/ErrorField"

/**
 * ラジオ・オプション
 */

interface Props {
  /**
   * 名前
   */
  name: string

  /**
   * クラス
   */
  className?: string

  /**
   * 表示するデータ
   */
  dataSource: Values[]

  /**
   * 選択値
   */
  value?: string | number

  /**
   * 確認画面モード
   */
  isConfirm?: boolean

  /**
   * バリデーション
   */
  validations?: {
    required?: boolean
  }

  /**
   * エラー時のタイトル
   */
  error?: string

  disabled?: boolean

  isSettingOwnerSign?: boolean

  /**
   * チェンジイベント
   */

  onChange?: (value: string | number | null) => void
}

export default function AcRadio(props: Props) {
  const {
    dataSource,
    value = null,
    name,
    isConfirm = false,
    validations,
    error,
    onChange,
    className,
    disabled = false,
    isSettingOwnerSign = false,
  } = props
  const inputDataSource = kv(dataSource, "value")
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const [currentValue, setCurrentValue] = useState<any>(value)

  const options = {
    onChange: (event) => {
      const index = event.target.id.replace(/^(.*?)+-/i, "")
      const value = dataSource[index].value
      setCurrentValue(value)
      onChange?.apply(this, [value])
    },
  }

  if (validations?.required) {
    Object.assign(options, {
      required: !disabled ? `${error || name}を選択してください` : false,
    })
  }

  return isConfirm ? (
    <FormLabel className={`isConfirm ${className}`}>
      {inputDataSource[currentValue ?? value]?.label as string}
    </FormLabel>
  ) : (
    <>
      {dataSource.map((data, index) => (
        <React.Fragment key={index}>
          <div className="form-check-inline">
            <Label
              htmlFor={`radio-${name}-${index}`}
              className={"form-label"}
              disabled={data.disable}
            >
              {isSettingOwnerSign ? (
                <Radio
                  disabled={disabled || data.disable}
                  id={`radio-${name}-${index}`}
                  {...register(name, options)}
                  type={"radio"}
                  value={data.value}
                  defaultChecked={data.value == value}
                  checked={data.value === value}
                />
              ) : (
                <Radio
                  disabled={disabled || data.disable}
                  id={`radio-${name}-${index}`}
                  {...register(name, options)}
                  type={"radio"}
                  value={data.value}
                  defaultChecked={data.value == value}
                />
              )}
              <CheckMark className="checkmark"></CheckMark>
              {data.label}
            </Label>
          </div>
        </React.Fragment>
      ))}
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => <ErrorField>{message}</ErrorField>}
      />
    </>
  )
}

const Label = styled.label`
  ${({ disabled }) => (disabled ? "opacity: 0.5;cursor: auto !important;" : "")}

  &.form-label {
    display: block;
    position: relative;
    padding-left: 30px;
    font-weight: normal;
    margin-bottom: 0;
  }

  &.isConfirm {
    padding-left: 0px;
  }
`

const Radio = styled.input`
  display: none;

  &:not(:checked) + .checkmark:before {
    border-color: ${(props) => (props.disabled ? "#B5B8BF" : "#6f6cff")};
  }

  &:checked + .checkmark:before {
    border-color: ${(props) => (props.disabled ? "#B5B8BF" : "#6f6cff")};
    background-color: ${(props) => (props.disabled ? "#B5B8BF" : "#6f6cff")};
  }

  &:disabled + .checkmark {
    cursor: auto;
  }
`

const CheckMark = styled.span`
  position: absolute;
  left: 0px;

  &:before {
    content: "";
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 6px;
    border-width: 1px;
    border-style: solid;
    border-radius: 50%;
    padding: 3px;
    background-clip: content-box;
    background-color: #ffffff;
  }
`
